export default "__VITE_ASSET__DYrx9S2J__"